import { EventActions } from '../../reducers/bookingCalendar/actionNames'

export default function(startDate, finishDate) {
  return {
    finishDate,
    startDate,
    type: EventActions.RequestEventsForCalendar,
  }
}
